import { useQuery } from '@tanstack/react-query';

import { recipientsApi } from '@/lib/recipients/api';
import { orgChartKeys } from '@/hooks/api/query-keys';
// Re-export the central mode-keyed factory so existing
// `import { orgChartKeys } from './use-org-chart'` consumers keep working.
export { orgChartKeys };

export interface OrgChartNode {
  id: string;
  name: string;
  email: string;
  department: string;
  designation: string;
  managerId: string | null;
  children?: OrgChartNode[];
  recipientCount?: number;
}

export interface OrgChartSearchResult {
  id: string;
  name: string;
  email: string;
  department: string;
  designation: string;
  path: string[];
}

export function useOrgChart() {
  return useQuery({
    queryKey: orgChartKeys.tree(),
    queryFn: () => recipientsApi<OrgChartNode[]>('org-chart'),
  });
}

export function useOrgChartSubtree(id: string) {
  return useQuery({
    queryKey: orgChartKeys.subtree(id),
    queryFn: () => recipientsApi<OrgChartNode>(`org-chart/subtree/${id}`),
    enabled: !!id,
  });
}

export function useOrgChartSearch(query: string) {
  return useQuery({
    queryKey: orgChartKeys.search(query),
    queryFn: () => recipientsApi<OrgChartSearchResult[]>(`org-chart/search?q=${encodeURIComponent(query)}`),
    // BE requires q ≥ 2 chars — gate here so a single keystroke doesn't fire a
    // guaranteed 400 (QA-4).
    enabled: query.trim().length >= 2,
  });
}
